import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Clock, Check, Kids, Location, getKids } from '../../utils';

import { HotelShortSection, HotelShortContainer, HotelShortList, HotelShortItem, HotelShortIcon } from './styles';

const HotelShortInfo = ({ address, workingHours, checkIn, childrenAreAllowed }) => (
  <HotelShortSection>
    <HotelShortContainer>
      <HotelShortList>
        <HotelShortItem>
          <HotelShortIcon>
            <Location />
          </HotelShortIcon>
          <address>
            {address}
          </address>
        </HotelShortItem>
        <HotelShortItem style={{ textTransform: 'uppercase' }}>
          <HotelShortIcon>
            <Clock />
          </HotelShortIcon>
          <span style={{ textTransform: 'capitalize' }}>Hours:</span>
          {workingHours}
        </HotelShortItem>
        <HotelShortItem>
          <HotelShortIcon>
            <Check />
          </HotelShortIcon>
          <span>Check In:</span>
          {checkIn}
        </HotelShortItem>
        <HotelShortItem>
          <HotelShortIcon>
            <Kids />
          </HotelShortIcon>
          <span>Children:</span>
          {getKids(childrenAreAllowed)}
        </HotelShortItem>
      </HotelShortList>
    </HotelShortContainer>
  </HotelShortSection>
);

HotelShortInfo.propTypes = {
  address: PropTypes.string,
  workingHours: PropTypes.string,
  checkIn: PropTypes.string,
  childrenAreAllowed: PropTypes.number,
};

const mapStateToProps = state => ({
  childrenAreAllowed: state.userProduct.product.isKidAllow,
});

export default connect(mapStateToProps)(HotelShortInfo);
